import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntdApp, Spin } from 'antd';
import './i18n';
import { LocaleProvider } from './i18n/LocaleProvider';
import { ToastProvider } from './utils/toast';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" /></div>}>
    <LocaleProvider
      theme={{
        token: {
          colorPrimary: '#2B803E',
        },
      }}
    >
      <AntdApp>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AntdApp>
    </LocaleProvider>
  </Suspense>
);

reportWebVitals();
